// extracted by mini-css-extract-plugin
var _1 = "tjs-share-panel__btn--catalogShare";
var _2 = "tjs-share-panel__btn--withoutText";
var _3 = "tjs-share-panel__btn--catalogShare";
var _4 = "tjs-share-panel__btn--withoutText";
var _5 = "tjs-share-panel__catalog-share";
var _6 = "tjs-share-panel__catalog-share";
var _7 = "tjs-share-panel__dropdown-inner";
var _8 = "tjs-share-panel__dropdown-inner";
var _9 = "tjs-share-panel__share-panel";
var _a = "tjs-share-panel__share-panel";
var _b = "tjs-share-panel__story-share";
var _c = "tjs-share-panel__story-share-inner";
var _d = "tjs-share-panel__story-share";
var _e = "tjs-share-panel__story-share-inner";
export { _1 as "btn--catalogShare", _2 as "btn--withoutText", _3 as "btnCatalogShare", _4 as "btnWithoutText", _5 as "catalog-share", _6 as "catalogShare", _7 as "dropdown-inner", _8 as "dropdownInner", _9 as "share-panel", _a as "sharePanel", _b as "story-share", _c as "story-share-inner", _d as "storyShare", _e as "storyShareInner" }
export default { "btn--catalogShare": _1, "btn--withoutText": _2, "btnCatalogShare": _3, "btnWithoutText": _4, "catalog-share": _5, "catalogShare": _6, "dropdown-inner": _7, "dropdownInner": _8, "share-panel": _9, "sharePanel": _a, "story-share": _b, "story-share-inner": _c, "storyShare": _d, "storyShareInner": _e }
